import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { defaultConfig, defaultConfigForKanban, defaultKanbanTheme, defaultTheme, } from './constants';
import './index.css';
import { KanbanBoardApp } from './kanban-board-app';
import { StagingApp } from './staging-widget';
var root = ReactDOM.createRoot(document.getElementById('root'));
root.render(_jsx(React.StrictMode, { children: _jsx(BrowserRouter, { children: _jsxs(Routes, { children: [_jsx(Route, { path: '/', element: _jsx(StagingApp, { config: defaultConfig, theme: defaultTheme }) }), _jsx(Route, { path: '/kanban', element: _jsx(KanbanBoardApp, { config: defaultConfigForKanban, theme: defaultKanbanTheme }) })] }) }) }));
